import * as React from "react";
import {none, Option} from "ts-option";
import DropDownList, {DropDownItem} from "../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import TextUtils from "../../../utils/TextUtils";
import AssetsSerialNumbersModal from "./AssetsSerialNumbersModal";
import SerialNumbersData from "../../../model/job/SerialNumbersData";

interface IComponentProps {
	/**
	 * Assets serial numbers
	 */
	serialNumbers: Option<SerialNumbersData>
	/**
	 * On change callback
	 * @param {Option<SerialNumbersData>} serial numbers
	 */
	onChange: (serialNumbers: Option<SerialNumbersData>) => void;
}

interface IState {
	/**
	 * Indicates if menu dropdown is visible.
	 */
	isMenuVisible: boolean;
	/**
	 * Indicates if edit serial numbers modal is visible.
	 */
	isEditModalVisible: boolean;
}

type Props = IComponentProps

export class AssetsSerialNumbers extends React.PureComponent<Props, IState> {
	menuFields: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Remove"},
		{id: "l3", label: "Copy"},
	];

	emptyFormMenuField: DropDownItem[] = [
		{id: "l1", label: "Change"}
	];

	constructor(props: Props) {
		super(props);
		this.state = {isMenuVisible: false, isEditModalVisible: false};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		const isSerialNumbersData = this.props.serialNumbers.map(sn => sn.isDefined()).getOrElse(false);
		const menuItems = isSerialNumbersData ? this.menuFields : this.emptyFormMenuField;
		return (
			<InfoModule icon={Icon.Job} title={"Assets serial numbers"} actionIcon={Icon.Overflow}
						onActionIconClick={this.toggleMenu}>
				{this.state.isMenuVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({isMenuVisible: false})}>
					<DropDownList items={menuItems}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.isEditModalVisible &&
				<AssetsSerialNumbersModal serialNumbers={this.props.serialNumbers}
										  onClose={() => {this.setState({isEditModalVisible: false})}}
										  onChange={this.onChange}/>}
				{isSerialNumbersData ?
					this.props.serialNumbers.map(t => {
							return (
								<ul className={"c-info-common-list"}>
									{t.boiler.map(b => {return (<li className={"t-body"}>Boiler: {b}</li>)}).orNull}
									{t.cylinder.map(c => {return (<li className={"t-body"}>Cylinder: {c}</li>)}).orNull}
									{t.filter.map(f => {return (<li className={"t-body"}>Filter: {f}</li>)}).orNull}
									{t.control.map(c => {return (<li className={"t-body"}>Control: {c}</li>)}).orNull}
								</ul>)
						}
					).get :
					<span className={"t-body"}>Serial numbers not provided</span>
				}
			</InfoModule>
		);
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({isMenuVisible: false});
		switch (item.id) {
			case "l1":
				this.setState({isMenuVisible: false, isEditModalVisible: true});
				break;
			case "l2":
				this.setState({isMenuVisible: false}, () => {this.props.onChange(none)});
				break;
			case "l3":
				this.props.serialNumbers.map(t => TextUtils.copyToClipboard(t.getText()));
				break;
		}
	}

	toggleMenu() {
		this.setState({isMenuVisible: !this.state.isMenuVisible})
	}

	onChange(serialNumbers: Option<SerialNumbersData>) {
		this.setState({isEditModalVisible: false}, () => this.props.onChange(serialNumbers));
	}
}
